export default __webpack_public_path__ + "static/media/TV.4afee09a.png";